<template>
  <section class="page_404">
    <div class="four_zero_four_bg"></div>
  </section>
</template>
<script>
export default {
  name: 'widgetErrorImg',
  props: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page_404 img {
  width: 100%;
}

.four_zero_four_bg {
  background-image: url("../../assets/images/errorImgGif.gif");
  height: 330px;
  background-position: center;
  background-repeat: no-repeat;
}</style>
